// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"512":"3d492524","680":"27f53a8e"}[chunkId] + ".chunk.css";
};